/**
 * ObjectHeaderPanel React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// react
import React from 'react';

// material UI
import {withStyles} from "@material-ui/core";
import Paper from '@material-ui/core/Paper';

// application
import ObjectHeader from './ObjectHeader';


/**
 * ObjectHeaderPanel is a React component for showing only the top of an object panel (its title)
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectHeaderPanel extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Paper className={classes.panel} elevation={1} style={{backgroundColor: this.getBackgroundColor(this.props.level)}}>
                    <div className={classes.innerPanel}>
                        <ObjectHeader objectType={this.props.objectType} object={this.props.object} modified={this.props.modified} />
                    </div>
                </Paper>
            </div>
        );
    }

    getBackgroundColor(level) {
        return ["#ffffff", "#f7f7f7", "#f3f3f3"][level] || "#efefef";
    }
}

const styles = {
    panel: {
        padding: "10px 0 10px 0",
        marginBottom: -5,
        backgroundImage: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.05))"
    },
    innerPanel: {
        height: 42,
        overflow: "hidden",
        marginBottom: -5
    }
};


export default withStyles(styles)(ObjectHeaderPanel);